import { useEffect, useState } from "react";
import { Dropdown, Menu } from "antd";

import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";

import i18n from "locales/i18n";
import { locales } from "config/locales.config";

import { StringParam, useQueryParams } from "use-query-params";
import styles from "./LangSelector.module.less";

function LangSelector(): JSX.Element {
  const [query, setQuery] = useQueryParams({
    lng: StringParam,
  });
  const [dropdownVisible, setDropdownVisible] = useState<boolean>(false);
  const initialLang = query.lng ?? i18n.language;
  const [selectedLanguage, setSelectedLanguage] = useState<string>(initialLang);

  const onLanguagechange = (language: string) => {
    i18n.changeLanguage(language, () => {
      setSelectedLanguage(language);
      setQuery({ lng: language }, "replaceIn");
      setDropdownVisible(false);
    });
  };

  useEffect(() => {
    const currentLanguage = i18n.language;
    if (currentLanguage !== selectedLanguage) {
      i18n.changeLanguage(selectedLanguage);
    }
  });

  const language = locales.find((item) => item.prefix === selectedLanguage);

  return (
    <Dropdown
      trigger={["click"]}
      visible={dropdownVisible}
      onVisibleChange={() => setDropdownVisible(!dropdownVisible)}
      overlay={
        <Menu theme="light">
          {locales.map(({ prefix, name, Icon }) => (
            <Menu.Item
              key={prefix}
              icon={
                <span className={styles.icon}>
                  <Icon />
                </span>
              }
              onClick={() => onLanguagechange(prefix)}
            >
              <span>{name}</span>
            </Menu.Item>
          ))}
        </Menu>
      }
    >
      <div className={styles.dropdown_wrapper}>
        {language && <language.Icon />}
        <p className={styles.user_name}>{language?.name}</p>
        {dropdownVisible ? <CaretUpOutlined /> : <CaretDownOutlined />}
      </div>
    </Dropdown>
  );
}

export default LangSelector;
